import firebase from "firebase";
export const initializeFirebase = () => {
    firebase.initializeApp({
        apiKey: "AIzaSyCusR7JshQoQAt8YQbI2y8YK_xXGOIc0NI",
        authDomain: "dnaproject-4ba7e.firebaseapp.com",
        projectId: "dnaproject-4ba7e",
        storageBucket: "dnaproject-4ba7e.appspot.com",
        messagingSenderId: "875159793242",
        appId: "1:875159793242:web:878bb63656f057af1c7263",
        measurementId: "G-VZ0XFKQK7J"
    });
}